import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import Async from 'modules/asyncCache/components/Async'
import useTranslate from 'modules/local/useTranslate'
import {IoHomeOutline} from 'react-icons/io5'
import {FaPeopleGroup, FaVenusMars} from 'react-icons/fa6'
import {MdElderly} from 'react-icons/md'
import {Link} from 'react-router-dom'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {familyBook_getFamilyBookStatsByParish_Api, familyBookMember_getMemberStatsByParish_Api, familyBookMember_getUpcomingMomentsByParish_Api} from 'apis/familyBook'
import {getId, getType} from 'apis/model/base'
import {MomentRow} from '../../AppLocals/FamilyBook/components/MomentRow'
// Icon RIÊNG đúng bí tích cho 4 tile "thiếu bí tích"/"tu sĩ" - dùng LẠI NGUYÊN bộ SacramentSvg đã có
// sẵn (đúng bộ đang dùng ở sidebar Workspace.js/WorkspaceFamilyBook.js), thay generic Io* icon cũ
// (giọt nước/ly/tia sét/ruy băng không gợi đúng ý nghĩa bí tích Công giáo).
import {BaptismSacramentSvg} from '../../../components/Svgs/BaptismSacramentSvg'
import {FirstCommunionSacramentSvg} from '../../../components/Svgs/FirstCommunionSacramentSvg'
import {ConfirmationSacramentSvg} from '../../../components/Svgs/ConfirmationSacramentSvg'
import {HolyOrdersSacramentSvg} from '../../../components/Svgs/HolyOrdersSacramentSvg'

// "Tổng Quan Giáo Dân" - block RIÊNG trên Tổng quan Workspace (KHÔNG nhét vào 4 card
// organization_summary vốn thuộc 1 API/1 phạm vi khác hẳn - org member/course/event/post, không biết
// gì về Sổ Gia Đình) - chỉ hiện khi org đã liên kết + được XÁC NHẬN với 1 giáo xứ
// (association_status===1, ĐÚNG điều kiện đã dùng cho tile "Hộ gia đình chờ duyệt" hiện có, không tự
// chế điều kiện khác). 3 nguồn dữ liệu ĐÃ CÓ SẴN (không thêm field/bảng mới):
//   - familyBook_getFamilyBookStatsByParish_Api - số hộ.
//   - familyBookMember_getMemberStatsByParish_Api - số giáo dân + giới tính/người già/tu sĩ/thiếu bí
//     tích (mới bổ sung field cho API này, xem comment đầu FamilyBookMemberController::
//     getMemberStatsByParish()).
//   - familyBookMember_getUpcomingMomentsByParish_Api (MỚI) - dùng lại NGUYÊN FamilyMomentHelper
//     (đã chạy cho "cây gia phả của tôi") cho TOÀN GIÁO XỨ, xem
//     FamilyBookMemberController::getUpcomingMomentsByParish().
const MiniStatTile = ({icon, label, value, color, t}) => (
    <div className="flex items-center gap-3 p-3 background border-t border-color-50 shadow-md rounded-xl">
        <div className={classNames('p-2 flex flex-center rounded-lg flex-shrink-0', color)}>{icon}</div>
        <div className="flex flex-col flex-1 min-w-0">
            <span className="font-medium text-gray-600 tracking-wide truncate">{t(label)}</span>
            <span className="font-bold text-lg text-color-000 leading-snug">{value}</span>
        </div>
    </div>
)

const WorkspaceParishOverviewSection = ({organization}) => {
    const t = useTranslate()
    if (Number(organization?.association_status) !== 1) return null

    const owner_type = getType(organization)
    const owner_id = getId(organization)
    const query = bindQueryParams([{type: owner_type}, {id: owner_id}])

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <span className="text-color-200 uppercase font-medium text-lg">{t('parish overview title')}</span>
                <Link to="/workspace/family_books?rel=family-book-member-lookup" className="text-xs font-semibold text-family-700 no-underline hover:underline">
                    {t('view details')}
                </Link>
            </div>

            <Async apiInfo={familyBook_getFamilyBookStatsByParish_Api} query={query} values={{}}>
                {({response: bookResponse}) => {
                    const bookStats = _.get(bookResponse, 'data', {})

                    return (
                        <Async apiInfo={familyBookMember_getMemberStatsByParish_Api} query={query} values={{}}>
                            {({response: memberResponse, isLoading}) => {
                                const s = _.get(memberResponse, 'data', {})
                                const gender = s.by_gender || {}

                                return (
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                        <MiniStatTile t={t} icon={<IoHomeOutline size={18}/>} color="text-blue-600 bg-blue-50"
                                                      label="total households stat label" value={isLoading ? '—' : (bookStats.total ?? 0)}/>
                                        <MiniStatTile t={t} icon={<FaPeopleGroup size={18}/>} color="text-green-600 bg-green-50"
                                                      label="total parishioners stat label" value={isLoading ? '—' : (s.total ?? 0)}/>
                                        <MiniStatTile t={t} icon={<FaVenusMars size={18}/>} color="text-pink-600 bg-pink-50"
                                                      label="gender breakdown stat label"
                                                      value={isLoading ? '—' : `${gender.male ?? 0} / ${gender.female ?? 0}`}/>
                                        <MiniStatTile t={t} icon={<MdElderly size={18}/>} color="text-slate-600 bg-slate-100"
                                                      label="elderly stat label" value={isLoading ? '—' : (s.elderly_count ?? 0)}/>
                                        <MiniStatTile t={t} icon={<HolyOrdersSacramentSvg size={18}/>} color="text-indigo-600 bg-indigo-50"
                                                      label="religious stat label" value={isLoading ? '—' : (s.religious_count ?? 0)}/>
                                        <MiniStatTile t={t} icon={<BaptismSacramentSvg size={18}/>} color="text-sky-600 bg-sky-50"
                                                      label="missing baptism stat label" value={isLoading ? '—' : (s.missing_baptism_count ?? 0)}/>
                                        <MiniStatTile t={t} icon={<FirstCommunionSacramentSvg size={18}/>} color="text-orange-600 bg-orange-50"
                                                      label="missing first communion stat label" value={isLoading ? '—' : (s.missing_first_communion_count ?? 0)}/>
                                        <MiniStatTile t={t} icon={<ConfirmationSacramentSvg size={18}/>} color="text-amber-600 bg-amber-50"
                                                      label="missing confirmation stat label" value={isLoading ? '—' : (s.missing_confirmation_count ?? 0)}/>
                                    </div>
                                )
                            }}
                        </Async>
                    )
                }}
            </Async>

            <div className="flex flex-col shadow-md background rounded-xl">
                <div className="px-3 py-2 background-200 rounded-t-xl flex items-center gap-3">
                    <span className="flex-1 font-medium text-sm text-gray-700 tracking-wide">{t('upcoming parish moments title')}</span>
                </div>
                <div className="p-3 flex flex-col gap-2">
                    <Async apiInfo={familyBookMember_getUpcomingMomentsByParish_Api} query={query} values={{}}>
                        {({response, isLoading}) => {
                            const moments = _.get(response, 'data.upcoming_moments', [])
                            if (isLoading) return <div className="py-6 text-center text-color-300 text-sm">{t('loading')}</div>
                            if (!moments.length) {
                                return <div className="py-6 text-center text-color-300 text-sm tracking-wide">{t('no upcoming moments')}</div>
                            }
                            return moments.map((item, i) => <MomentRow key={i} item={item} t={t}/>)
                        }}
                    </Async>
                </div>
            </div>
        </div>
    )
}

export default WorkspaceParishOverviewSection
